var app = new function () {
    this.components = {};
    this.init = function () {
        var that = this;
        that.call('addListener');
        $(window).on('resize orientationchange', function () {
            that.call('resize');
        }).trigger('resize');
        $(window).on('scroll', function () {
            that.call('scroll');
        }).trigger('scroll');
    };
    this.call = function (event) {
        var that = this;
        var _return;
        if (typeof event === 'string') {
            event = {'name': event, 'arg': that};
        }
        $.each(that.components, function (index, element) {
            if (typeof element.global == 'undefined'){
                element.global = false;
            }
            if (typeof element[event.name] === 'function') {
                if (element.global == true || element['onReady']() === true){
                    element[event.name](event.arg);
                }
            }
        });
    };
    this.require = function (arr) {
        var that = this;
        var path = '/content/themes/master/static/js/vendor/';
        var _arr = $.map(arr, function (scr) {
            return $.cachedScript((path || "") + scr);
        });
        _arr.push($.Deferred(function (deferred) {
            $(deferred.resolve);
        }));
        return $.when.apply($, _arr);
    };
};
;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

		// AMD. Register as an anonymous module.
		define(function() {
			return FastClick;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


app.components.base = {
    global: true,
    addListener: function () {
        var that = this;

        FastClick.attach( document.body );
        $("html").removeClass("no-js");

        // detect ie11
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (isIE11){
            $('html').addClass('ie11');
        }

        // add pdf class and open link in new window
        $("a[href$='pdf']").attr("target","_blank");

        // Open External Links In New Window
        $('a').each(function() {
            if($(this).attr("href") && $(this).attr("href").indexOf("#") === 0) {
                return;
            }
            var a = new RegExp('/' + window.location.host + '/');
            var b = new RegExp(/(mailto:.*)/g);
            if(!a.test(this.href) && !b.test(this.href)){
                $(this).attr('rel','external');
                $(this).attr("target","_blank");
            } else {
                $(this).attr('rel','internal');
            }
        });

        // link has image
        $('a:has(img)').addClass('hasImage');

        if ($("body.scrollbehavior--default").length){

            let scrollToElement = (hash) => {
                hash = hash.replace('#','');
                let elementOffset = $('.section[data-anchor="'+hash+'"]').offset();
                if (!elementOffset){
                    elementOffset = $('#'+hash).offset();
                }
                if (elementOffset){
                    elementOffset = elementOffset.top  - 40;
                    $('html, body').stop().animate({
                        'scrollTop': elementOffset
                    }, 750, 'swing', function () {
                        $(document).trigger("scroll");
                    });
                }
            }

            // hash links

            $(window).on('hashchange', function() {
                var hash = window.location.hash;
                $('html.mobile-nav-is-visible').removeClass('mobile-nav-is-visible');
                if (hash){
                    setTimeout(() => {
                        scrollToElement(hash);
                    }, 100);
                }
            }).trigger('hashchange');
        }

        // course date list sticky
        var courseDateListEl = $('.course-detail__dates');

        if(courseDateListEl.length && $('body').width() > 1024) {
            app.require(['sticky.min.js']).done(() => {
                var sticky = new Sticky('.course-detail__dates');
            });
        }

        // sticky bar behaviour
        var stickyBarEl = $('.sticky-bar');

        if(stickyBarEl.length && $('body').width() > 1024) {
            app.require(['sticky.min.js']).done(() => {
                var sticky = new Sticky('.sticky-bar');
            });
        }

        // course & jobs back link
        var isCourseDetail = !!$('body.single-webinare').length;

        if(isCourseDetail && $('body').width() > 1024 ) {
            var backLinkEl = $('.course-detail__back');
            var headerContainerEl = $('.js-header > .section > .container');

            if(backLinkEl.length && headerContainerEl.length) {
                backLinkEl.clone().appendTo(headerContainerEl);
            }
        }

        // image masks
        var imageMaskEl = $('img[class*="js-image-mask"]');

        if(imageMaskEl.length) {
            imageMaskEl.each(function() {
                var imageEl = $(this);
                var mask = imageEl.data('mask');

                if(mask) {
                    imageEl.wrap(`<div class='c-image-mask c-image-mask--${mask}'></div>`);
                }
            });
        }
    }
};
app.components.accordion_tutorials = {
    onReady: function () {
        if ($('.c-accordion_tutorials').length) {
            return true;
        }
    },
    addListener: function () {
        $('.c-accordion_tutorials').find('.c-accordion_tutorials__header').on('click', function () {
            $(this).toggleClass('c-accordion_tutorials__header--active');
            $('.c-accordion_tutorials__header').not($(this)).removeClass('c-accordion_tutorials__header--active');
            $(this).next().slideToggle('fast');
            $(".c-accordion_tutorials__content").not($(this).next()).slideUp('fast');
        });

        $(window).on('hashchange', function () {
            var hash = window.location.hash;
            if (hash && $(hash + '.c-accordion_tutorials__header').length) {
                $(hash + '.c-accordion_tutorials__header').trigger('click');
            }
        }).trigger('hashchange');
    }
};
app.components.accordion = {
    onReady: function () {
        if ($('.c-accordion').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;
        $('.c-accordion').find('.c-accordion__header').on('click', function () {
            $(this).toggleClass('c-accordion__header--active');
            $('.c-accordion__header').not($(this)).removeClass('c-accordion__header--active');
            $(this).next().slideToggle('fast');
            $(".c-accordion__content").not($(this).next()).slideUp('fast');
        });
    }
};
app.components.animations = {
    onReady: () => {
        var that = this;
        if (!$("body.scrollbehavior--fullscreen").length && $('[data-aos]').length) { // disable on fullscreen
            return true;
        }
    },
    addListener: () => {
        app.require(['aos.min.js']).done(() => {
            AOS.init({
                disable: false,
                startEvent: 'DOMContentLoaded',
                animatedClassName: 'aos-animate',
                useClassNames: false,
                disableMutationObserver: false,
                debounceDelay: 50,
                throttleDelay: 99,
                offset: 120,
                delay: 0,
                duration: 500,
                easing: 'ease',
                once: false,
                mirror: false,
                anchorPlacement: 'top-bottom'
            });
        });
    }
};
/*!
 * Waves v0.6.4
 * http://fian.my.id/Waves
 *
 * Copyright 2014 Alfiana E. Sibuea and other contributors
 * Released under the MIT license
 * https://github.com/fians/Waves/blob/master/LICENSE
 */

;(function(window) {
    'use strict';

    var Waves = Waves || {};
    var $$ = document.querySelectorAll.bind(document);

    // Find exact position of element
    function isWindow(obj) {
        return obj !== null && obj === obj.window;
    }

    function getWindow(elem) {
        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    }

    function offset(elem) {
        var docElem, win,
            box = {top: 0, left: 0},
            doc = elem && elem.ownerDocument;

        docElem = doc.documentElement;

        if (typeof elem.getBoundingClientRect !== typeof undefined) {
            box = elem.getBoundingClientRect();
        }
        win = getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    }

    function convertStyle(obj) {
        var style = '';

        for (var a in obj) {
            if (obj.hasOwnProperty(a)) {
                style += (a + ':' + obj[a] + ';');
            }
        }

        return style;
    }

    var Effect = {

        // Effect delay
        duration: 750,

        show: function(e, element) {

            // Disable right click
            if (e.button === 2) {
                return false;
            }

            var el = element || this;

            // Create ripple
            var ripple = document.createElement('div');
            ripple.className = 'waves-ripple';
            el.appendChild(ripple);

            // Get click coordinate and element witdh
            var pos         = offset(el);
            var relativeY   = (e.pageY - pos.top);
            var relativeX   = (e.pageX - pos.left);
            var scale       = 'scale('+((el.clientWidth / 100) * 10)+')';

            // Support for touch devices
            if ('touches' in e) {
              relativeY   = (e.touches[0].pageY - pos.top);
              relativeX   = (e.touches[0].pageX - pos.left);
            }

            // Attach data to element
            ripple.setAttribute('data-hold', Date.now());
            ripple.setAttribute('data-scale', scale);
            ripple.setAttribute('data-x', relativeX);
            ripple.setAttribute('data-y', relativeY);

            // Set ripple position
            var rippleStyle = {
                'top': relativeY+'px',
                'left': relativeX+'px'
            };

            ripple.className = ripple.className + ' waves-notransition';
            ripple.setAttribute('style', convertStyle(rippleStyle));
            ripple.className = ripple.className.replace('waves-notransition', '');

            // Scale the ripple
            rippleStyle['-webkit-transform'] = scale;
            rippleStyle['-moz-transform'] = scale;
            rippleStyle['-ms-transform'] = scale;
            rippleStyle['-o-transform'] = scale;
            rippleStyle.transform = scale;
            rippleStyle.opacity   = '1';

            rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-moz-transition-duration']    = Effect.duration + 'ms';
            rippleStyle['-o-transition-duration']      = Effect.duration + 'ms';
            rippleStyle['transition-duration']         = Effect.duration + 'ms';

            rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-moz-transition-timing-function']    = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-o-transition-timing-function']      = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['transition-timing-function']         = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

            ripple.setAttribute('style', convertStyle(rippleStyle));
        },

        hide: function(e) {
            TouchHandler.touchup(e);

            var el = this;
            var width = el.clientWidth * 1.4;

            // Get first ripple
            var ripple = null;
            var ripples = el.getElementsByClassName('waves-ripple');
            if (ripples.length > 0) {
                ripple = ripples[ripples.length - 1];
            } else {
                return false;
            }

            var relativeX   = ripple.getAttribute('data-x');
            var relativeY   = ripple.getAttribute('data-y');
            var scale       = ripple.getAttribute('data-scale');

            // Get delay beetween mousedown and mouse leave
            var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
            var delay = 350 - diff;

            if (delay < 0) {
                delay = 0;
            }

            // Fade out ripple after delay
            setTimeout(function() {
                var style = {
                    'top': relativeY+'px',
                    'left': relativeX+'px',
                    'opacity': '0',

                    // Duration
                    '-webkit-transition-duration': Effect.duration + 'ms',
                    '-moz-transition-duration': Effect.duration + 'ms',
                    '-o-transition-duration': Effect.duration + 'ms',
                    'transition-duration': Effect.duration + 'ms',
                    '-webkit-transform': scale,
                    '-moz-transform': scale,
                    '-ms-transform': scale,
                    '-o-transform': scale,
                    'transform': scale,
                };

                ripple.setAttribute('style', convertStyle(style));

                setTimeout(function() {
                    try {
                        el.removeChild(ripple);
                    } catch(e) {
                        return false;
                    }
                }, Effect.duration);
            }, delay);
        },

        // Little hack to make <input> can perform waves effect
        wrapInput: function(elements) {
            for (var a = 0; a < elements.length; a++) {
                var el = elements[a];

                if (el.tagName.toLowerCase() === 'input') {
                    var parent = el.parentNode;

                    // If input already have parent just pass through
                    if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
                        continue;
                    }

                    // Put element class and style to the specified parent
                    var wrapper = document.createElement('i');
                    wrapper.className = el.className + ' waves-input-wrapper';

                    var elementStyle = el.getAttribute('style');

                    if (!elementStyle) {
                        elementStyle = '';
                    }

                    wrapper.setAttribute('style', elementStyle);

                    el.className = 'waves-button-input';
                    el.removeAttribute('style');

                    // Put element as child
                    parent.replaceChild(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        }
    };


    /**
     * Disable mousedown event for 500ms during and after touch
     */
    var TouchHandler = {
        /* uses an integer rather than bool so there's no issues with
         * needing to clear timeouts if another touch event occurred
         * within the 500ms. Cannot mouseup between touchstart and
         * touchend, nor in the 500ms after touchend. */
        touches: 0,
        allowEvent: function(e) {
            var allow = true;

            if (e.type === 'touchstart') {
                TouchHandler.touches += 1; //push
            } else if (e.type === 'touchend' || e.type === 'touchcancel') {
                setTimeout(function() {
                    if (TouchHandler.touches > 0) {
                        TouchHandler.touches -= 1; //pop after 500ms
                    }
                }, 500);
            } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
                allow = false;
            }

            return allow;
        },
        touchup: function(e) {
            TouchHandler.allowEvent(e);
        }
    };


    /**
     * Delegated click handler for .waves-effect element.
     * returns null when .waves-effect element not in "click tree"
     */
    function getWavesEffectElement(e) {
        if (TouchHandler.allowEvent(e) === false) {
            return null;
        }

        var element = null;
        var target = e.target || e.srcElement;

        while (target.parentNode !== null) {
            if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
                element = target;
                break;
            }
            target = target.parentNode;
        }
        return element;
    }

    /**
     * Bubble the click and show effect if .waves-effect elem was found
     */
    function showEffect(e) {
        var element = getWavesEffectElement(e);

        if (element !== null) {
            Effect.show(e, element);

            if ('ontouchstart' in window) {
                element.addEventListener('touchend', Effect.hide, false);
                element.addEventListener('touchcancel', Effect.hide, false);
            }

            element.addEventListener('mouseup', Effect.hide, false);
            element.addEventListener('mouseleave', Effect.hide, false);
            element.addEventListener('dragend', Effect.hide, false);
        }
    }

    Waves.displayEffect = function(options) {
        options = options || {};

        if ('duration' in options) {
            Effect.duration = options.duration;
        }

        //Wrap input inside <i> tag
        Effect.wrapInput($$('.waves-effect'));

        if ('ontouchstart' in window) {
            document.body.addEventListener('touchstart', showEffect, false);
        }

        document.body.addEventListener('mousedown', showEffect, false);
    };

    /**
     * Attach Waves to an input element (or any element which doesn't
     * bubble mouseup/mousedown events).
     *   Intended to be used with dynamically loaded forms/inputs, or
     * where the user doesn't want a delegated click handler.
     */
    Waves.attach = function(element) {
        //FUTURE: automatically add waves classes and allow users
        // to specify them with an options param? Eg. light/classic/button
        if (element.tagName.toLowerCase() === 'input') {
            Effect.wrapInput([element]);
            element = element.parentNode;
        }

        if ('ontouchstart' in window) {
            element.addEventListener('touchstart', showEffect, false);
        }

        element.addEventListener('mousedown', showEffect, false);
    };

    window.Waves = Waves;

    document.addEventListener('DOMContentLoaded', function() {
        Waves.displayEffect();
    }, false);

})(window);


app.components.button = {
    onReady: function () {
        if ($('.c-button').length) {
            return true;
        }
    },
    addListener: function () {
        $('.c-button a').addClass('waves-effect waves-light');
    }
};

app.components.contact_widget = {
    onReady: function () {
        if ($('.c-contact_widget').length) {
            return true;
        }
    },
    addListener: function () {
        var widgetEl = $('.c-contact_widget');
        var widgetToggleEl = $('.c-contact-widget__toggle');
        var navigationToggle = $('.c-navigation__toggle');

        var siteContent = $('.site-content');
        var html = $('html');

        if( $('body').width() >= 1024 ) {
            widgetEl.on("mouseover", function () {
                html.toggleClass('is-contact-widget-open');

                return false;
            });

            widgetEl.on("mouseout", function () {
                html.removeClass('is-contact-widget-open');

                return false;
            });
        }

        widgetToggleEl.on("click", function () {
            if ( $('body').width() <= 1024 ){
                if(html.hasClass('is-contact-widget-open')) {
                    siteContent.css({'transform' : 'translateY(0px)'});
                } else {
                    if(html.hasClass('mobile-nav-is-visible')) {
                        navigationToggle.trigger('click');
                    }

                    siteContent.css({'transform' : 'translateY(' + widgetEl.outerHeight() + 'px)'});
                }
            }

            html.toggleClass('is-contact-widget-open');

            return false;
        });
    },
};
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


app.components.cookie_policy = {
    onReady: function () {
        if ($('.c-cookie_policy').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;
        $('.c-cookie_policy').on('click', function(){
           $(this).addClass('close');
        });
        $('.c-cookie_policy button.read').on('click', function(){
            Cookies.set('CookieConsent', 1, { expires: 365, path: '/' });
        });
        if (!Cookies.get('CookieConsent')){
            $('.c-cookie_policy').removeClass('close');
        }
    }
};

app.components.course_list = {
    global: false,
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

    }
};
app.components.downloads = {
    onReady: function () {
        if ($('.c-downloads').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;

        var $container = $('.c-downloads');

        $('.c-downloads__header', $container).on('click', function(){
            var header = $(this);
            var content = $(this).next('div').eq(0);
            var duration = 200;
            if (content.hasClass('c-downloads__files--active')){
                header.removeClass('c-downloads__header--active');
                content.removeClass('c-downloads__files--active').slideUp(duration);
            } else {
                $('.c-downloads__header--active', $container).removeClass('c-downloads__header--active');
                $('.c-downloads__files--active', $container).removeClass('c-downloads__files--active').slideUp(duration);
                header.addClass('c-downloads__header--active');
                content.addClass('c-downloads__files--active').slideDown(duration);
            }
        });
    }
}
app.components.footer = {
    global: true,
    addListener: function () {
        var arrowUpEl = $('.js-up-arrow');

        if(arrowUpEl.length) {
            $('.js-up-arrow').append('<button class="footer__arrow-up js-arrow-up-trigger"><i class="icon--arrow-up"></i></button>');

            $('.js-arrow-up-trigger').on('click', function(e) {
                $('body,html').animate({
                    scrollTop: 0
                }, 800);

                return false;
            });
        }
    }
};
app.components.form = {
    onReady: function () {

        if ($('.wpforms-container').length) {

            $(document).on("done_load_repeater", function () {
                app.require(['jcf.min.js']).done(() => {
                    app.require(['jcf.radio.min.js', 'jcf.checkbox.min.js']).done(() => {
                        jcf.replaceAll($('.wpforms-field-repeater'));
                    });
                });
            }).trigger('done_load_repeater');
            
            $(document).on("click", ".wpforms-field-repeater-button-add", function () {
                $(document).trigger('done_load_repeater');
            });

            setTimeout(() => {
                $(document).trigger('done_load_repeater');
            }, 1000);

            return true;

        }
    },
    addListener: function () {

        var that = this;

        $container = $('.wpforms-container');

        app.require(['jcf.min.js']).done(() => {
            app.require(['jcf.radio.min.js', 'jcf.checkbox.min.js']).done(() => {
                jcf.replaceAll($container);
            });
        });

        let maxlength = 200;
        $('.wpf-char-limit textarea').attr('maxlength', maxlength);
        $('.wpf-char-limit textarea').each(function () {
            let id = $(this).attr('id');
            $(this).after('<span class="textarea_counter">Noch <span data-textarea="' + id + '">' + maxlength + '</span> Zeichen</span>');
        });
        $('.wpf-char-limit textarea').keyup(function () {
            var count = parseInt($(this).attr('maxlength')) - parseInt($(this).val().length);
            var id = $(this).attr('id');
            if (isNaN(count)) return false;
            $('span[data-textarea="' + id + '"]').text(count);
        }).trigger('keyup');

        $("body").on('input change', 'input, textarea, select', $container, function () {
            var $field = $(this).closest('div.wpforms-field');
            if (this.value) {
                $field.addClass('field--not-empty');
            } else {
                $field.removeClass('field--not-empty');
            }
        });
        $('input, textarea, select', $container).trigger('input');

        $("body").on('focusin', 'input, textarea, select', $container, function () {
            var $field = $(this).closest('div.wpforms-field');
            $field.addClass('field--not-empty');
        });

        $("body").on('click', 'label', $container, function () {
            var $field = $(this).closest('div.wpforms-field');
            $field.addClass('field--not-empty');
        });

        $("body").on('focusout', 'input, textarea, select', $container, function () {
            $(this).trigger('input');
        });

        var wpFormsSubmit = $('.wpforms-submit-container');

        if (wpFormsSubmit.length && $('body').width() > 1024) {
            wpFormsSubmit.appendTo('.wpforms-field-container-right');
        }

        function getQueryParams(qs) {
            qs = qs.split('+').join(' ');
            var params = {},
                tokens,
                re = /[?&]?([^=]+)=([^&]*)/g;
            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            }
            return params;
        }

        var query = getQueryParams(document.location.search);
        if (typeof query.wohnung !== 'undefined') {
            $('.wpforms-field-text.apartment input').val(query.wohnung).trigger('change');
        } else {
            $('.wpforms-field-text.apartment').hide();
        }
    }
};

app.components.fullpage = {
    onReady: () => {
        if ($("body.scrollbehavior--fullscreen").length) {
            return true;
        }
    },
    addListener: () => {
        app.require(['fullpage.extensions.min.js', 'scrolloverflow.min.js']).done(() => {
            $('main').fullpage({
                licenseKey: "74CC0E79-8A8C493F-B7F31554-4EF304FB",
                lockAnchors: true,
                scrollOverflow: true,
                responsiveWidth: 1024,
                sectionSelector: '.section--fullscreen, .section--height-3-4, .section--height-2-4, .section--height-1-4, .section--footer',
                afterRender: function () {
                },
                onLeave: function (origin, destination, direction) {
                    // shrink header solution for fullpage.js
                    if (direction == 'down') {
                        $('header').removeClass('shrinkOn').addClass("shrinkOff");
                    } else if (origin.index == 1 && direction == 'up') {
                        $('header').removeClass('shrinkOn shrinkOff');
                    } else if (direction == 'up') {
                        $('header').removeClass('shrinkOff').addClass('shrinkOn');
                    }
                }
            });
        });

        $('a[href^="#"]').on('click', function (e) {
            var target = $(this).attr('href');
            target = target.replace('#', '');
            $.fn.fullpage.moveTo(target);
            e.preventDefault();
        });
    }
};
/*
    The MIT License (MIT)

    Copyright (c) 2014 Dirk Groenen

    Permission is hereby granted, free of charge, to any person obtaining a copy of
    this software and associated documentation files (the "Software"), to deal in
    the Software without restriction, including without limitation the rights to
    use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
    the Software, and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.
*/

(function($){
    $.fn.viewportChecker = function(useroptions){
        // Define options and extend with user
        var options = {
            classToAdd: 'visible',
            classToRemove : 'invisible',
            classToAddForFullView : 'full-visible',
            removeClassAfterAnimation: false,
            offset: 100,
            repeat: false,
            invertBottomOffset: true,
            callbackFunction: function(elem, action){},
            scrollHorizontal: false,
            scrollBox: window
        };
        $.extend(options, useroptions);

        // Cache the given element and height of the browser
        var $elem = this,
            boxSize = {height: $(options.scrollBox).height(), width: $(options.scrollBox).width()};

        /*
         * Main method that checks the elements and adds or removes the class(es)
         */
        this.checkElements = function(){
            var viewportStart, viewportEnd;

            // Set some vars to check with
            if (!options.scrollHorizontal){
                viewportStart = Math.max(
                    $('html').scrollTop(),
                    $('body').scrollTop(),
                    $(window).scrollTop()
                );
                viewportEnd = (viewportStart + boxSize.height);
            }
            else{
                viewportStart = Math.max(
                    $('html').scrollLeft(),
                    $('body').scrollLeft(),
                    $(window).scrollLeft()
                );
                viewportEnd = (viewportStart + boxSize.width);
            }

            // Loop through all given dom elements
            $elem.each(function(){
                var $obj = $(this),
                    objOptions = {},
                    attrOptions = {};

                //  Get any individual attribution data
                if ($obj.data('vp-add-class'))
                    attrOptions.classToAdd = $obj.data('vp-add-class');
                if ($obj.data('vp-remove-class'))
                    attrOptions.classToRemove = $obj.data('vp-remove-class');
                if ($obj.data('vp-add-class-full-view'))
                    attrOptions.classToAddForFullView = $obj.data('vp-add-class-full-view');
                if ($obj.data('vp-keep-add-class'))
                    attrOptions.removeClassAfterAnimation = $obj.data('vp-remove-after-animation');
                if ($obj.data('vp-offset'))
                    attrOptions.offset = $obj.data('vp-offset');
                if ($obj.data('vp-repeat'))
                    attrOptions.repeat = $obj.data('vp-repeat');
                if ($obj.data('vp-scrollHorizontal'))
                    attrOptions.scrollHorizontal = $obj.data('vp-scrollHorizontal');
                if ($obj.data('vp-invertBottomOffset'))
                    attrOptions.scrollHorizontal = $obj.data('vp-invertBottomOffset');

                // Extend objOptions with data attributes and default options
                $.extend(objOptions, options);
                $.extend(objOptions, attrOptions);

                // If class already exists; quit
                if ($obj.data('vp-animated') && !objOptions.repeat){
                    return;
                }

                // Check if the offset is percentage based
                if (String(objOptions.offset).indexOf("%") > 0)
                    objOptions.offset = (parseInt(objOptions.offset) / 100) * boxSize.height;

                // Get the raw start and end positions
                var rawStart = (!objOptions.scrollHorizontal) ? $obj.offset().top : $obj.offset().left,
                    rawEnd = (!objOptions.scrollHorizontal) ? rawStart + $obj.height() : rawStart + $obj.width();

                // Add the defined offset
                var elemStart = Math.round( rawStart ) + objOptions.offset,
                    elemEnd = (!objOptions.scrollHorizontal) ? elemStart + $obj.height() : elemStart + $obj.width();

                if (objOptions.invertBottomOffset)
                    elemEnd -= (objOptions.offset * 2);

                // Add class if in viewport
                if ((elemStart < viewportEnd) && (elemEnd > viewportStart)){

                    // Remove class
                    $obj.removeClass(objOptions.classToRemove);
                    $obj.addClass(objOptions.classToAdd);

                    // Do the callback function. Callback wil send the jQuery object as parameter
                    objOptions.callbackFunction($obj, "add");

                    // Check if full element is in view
                    if (rawEnd <= viewportEnd && rawStart >= viewportStart)
                        $obj.addClass(objOptions.classToAddForFullView);
                    else
                        $obj.removeClass(objOptions.classToAddForFullView);

                    // Set element as already animated
                    $obj.data('vp-animated', true);

                    if (objOptions.removeClassAfterAnimation) {
                        $obj.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                            $obj.removeClass(objOptions.classToAdd);
                        });
                    }

                // Remove class if not in viewport and repeat is true
                } else if ($obj.hasClass(objOptions.classToAdd) && (objOptions.repeat)){
                    $obj.removeClass(objOptions.classToAdd + " " + objOptions.classToAddForFullView);

                    // Do the callback function.
                    objOptions.callbackFunction($obj, "remove");

                    // Remove already-animated-flag
                    $obj.data('vp-animated', false);
                }
            });

        };

        /**
         * Binding the correct event listener is still a tricky thing.
         * People have expierenced sloppy scrolling when both scroll and touch
         * events are added, but to make sure devices with both scroll and touch
         * are handles too we always have to add the window.scroll event
         *
         * @see  https://github.com/dirkgroenen/jQuery-viewport-checker/issues/25
         * @see  https://github.com/dirkgroenen/jQuery-viewport-checker/issues/27
         */

        // Select the correct events
        if( 'ontouchstart' in window || 'onmsgesturechange' in window ){
            // Device with touchscreen
            $(document).bind("touchmove MSPointerMove pointermove", this.checkElements);
        }

        // Always load on window load
        $(options.scrollBox).bind("load scroll", this.checkElements);

        // On resize change the height var
        $(window).resize(function(e){
            boxSize = {height: $(options.scrollBox).height(), width: $(options.scrollBox).width()};
            $elem.checkElements();
        });

        // trigger inital check if elements already visible
        this.checkElements();

        // Default jquery plugin behaviour
        return this;
    };
})(jQuery);


app.components.googlemap = {
    onReady: function () {
        if ($('.googlemap-canvas').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;
        $('.googlemap-canvas').viewportChecker({
            callbackFunction: function (elem) {
                elem =  $(elem).attr('id');
                if (window.google && google.maps) {
                    that.initMap(elem);
                } else {
                    that.lazyLoad(elem);
                }
            }
        });
    },
    lazyLoad: function (elem) {
        var that = this;
        var callBackName = elem + "_callback";
        window[callBackName] = new Function(" app.components.googlemap.initMap(\""+ elem +"\")");
        $.getScript("https://maps.google.com/maps/api/js?key=" + window.googlemap.key + "&callback=window." + callBackName);
    },
    initMap: function (elem) {

        var map = new google.maps.Map(document.getElementById(elem), {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            panControl: true,
            panControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
        });

        /*map.setOptions({
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 65
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": "50"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "40"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#ffff00"
                        },
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -97
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -100
                        }
                    ]
                }
            ]
        });*/

        var infowindow = new google.maps.InfoWindow();
        var bounds = new google.maps.LatLngBounds();
        var marker = null;

        for (i = 0; i < window.googlemap.locations[elem].length; i++) {
            var location = googlemap.locations[elem][i];
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.lat, location.lng),
                map: map,
                icon: {
                    url: location.icon,
                    scaledSize: new google.maps.Size(38, 54),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(19, 54)
                },
                title: location.title
            });

            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent(location.content);
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }

        // add offset              
        //bounds.extend(new google.maps.LatLng(bounds.getCenter().lat() + 0.007, bounds.getCenter().lng()));
        map.fitBounds(bounds);

        var listener = google.maps.event.addListener(map, "idle", function () {
            map.setZoom(17);
            google.maps.event.removeListener(listener);
        });

    }
};
app.components.header = {
    global: true,
    intro: {},
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

        var that = this;

        that.intro.scrollY = $(document).scrollTop();

        if (!that.intro.lastScrollY) {
            that.intro.lastScrollY = 0;
        }

        if (that.intro.scrollY) {
            if (that.intro.lastScrollY > that.intro.scrollY) {
                $('header').removeClass('shrinkOff').addClass('shrinkOn');
            } else {
                $('header').removeClass('shrinkOn').addClass("shrinkOff");
            }
        } else {
            $('header').removeClass('shrinkOn shrinkOff');
        }

        that.intro.lastScrollY = that.intro.scrollY;

    }
};
app.components.iframe = {
    onReady: function () {
        if ($('.c-iframe__iframe').length) {
            return true;
        }
    },
    resize: function () {
        var iframe = {};
        iframe.el = $('.c-iframe__iframe');
        iframe.width = iframe.el.width();
        iframe.height = iframe.el.width() / iframe.el.data('aspect-ratio');
        iframe.el.height(iframe.height);
    }
};
/*! jQuery & Zepto Lazy v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function(t,e){"use strict";function r(r,a,i,u,l){function f(){L=t.devicePixelRatio>1,i=c(i),a.delay>=0&&setTimeout(function(){s(!0)},a.delay),(a.delay<0||a.combined)&&(u.e=v(a.throttle,function(t){"resize"===t.type&&(w=B=-1),s(t.all)}),u.a=function(t){t=c(t),i.push.apply(i,t)},u.g=function(){return i=n(i).filter(function(){return!n(this).data(a.loadedName)})},u.f=function(t){for(var e=0;e<t.length;e++){var r=i.filter(function(){return this===t[e]});r.length&&s(!1,r)}},s(),n(a.appendScroll).on("scroll."+l+" resize."+l,u.e))}function c(t){var i=a.defaultImage,o=a.placeholder,u=a.imageBase,l=a.srcsetAttribute,f=a.loaderAttribute,c=a._f||{};t=n(t).filter(function(){var t=n(this),r=m(this);return!t.data(a.handledName)&&(t.attr(a.attribute)||t.attr(l)||t.attr(f)||c[r]!==e)}).data("plugin_"+a.name,r);for(var s=0,d=t.length;s<d;s++){var A=n(t[s]),g=m(t[s]),h=A.attr(a.imageBaseAttribute)||u;g===N&&h&&A.attr(l)&&A.attr(l,b(A.attr(l),h)),c[g]===e||A.attr(f)||A.attr(f,c[g]),g===N&&i&&!A.attr(E)?A.attr(E,i):g===N||!o||A.css(O)&&"none"!==A.css(O)||A.css(O,"url('"+o+"')")}return t}function s(t,e){if(!i.length)return void(a.autoDestroy&&r.destroy());for(var o=e||i,u=!1,l=a.imageBase||"",f=a.srcsetAttribute,c=a.handledName,s=0;s<o.length;s++)if(t||e||A(o[s])){var g=n(o[s]),h=m(o[s]),b=g.attr(a.attribute),v=g.attr(a.imageBaseAttribute)||l,p=g.attr(a.loaderAttribute);g.data(c)||a.visibleOnly&&!g.is(":visible")||!((b||g.attr(f))&&(h===N&&(v+b!==g.attr(E)||g.attr(f)!==g.attr(F))||h!==N&&v+b!==g.css(O))||p)||(u=!0,g.data(c,!0),d(g,h,v,p))}u&&(i=n(i).filter(function(){return!n(this).data(c)}))}function d(t,e,r,i){++z;var o=function(){y("onError",t),p(),o=n.noop};y("beforeLoad",t);var u=a.attribute,l=a.srcsetAttribute,f=a.sizesAttribute,c=a.retinaAttribute,s=a.removeAttribute,d=a.loadedName,A=t.attr(c);if(i){var g=function(){s&&t.removeAttr(a.loaderAttribute),t.data(d,!0),y(T,t),setTimeout(p,1),g=n.noop};t.off(I).one(I,o).one(D,g),y(i,t,function(e){e?(t.off(D),g()):(t.off(I),o())})||t.trigger(I)}else{var h=n(new Image);h.one(I,o).one(D,function(){t.hide(),e===N?t.attr(C,h.attr(C)).attr(F,h.attr(F)).attr(E,h.attr(E)):t.css(O,"url('"+h.attr(E)+"')"),t[a.effect](a.effectTime),s&&(t.removeAttr(u+" "+l+" "+c+" "+a.imageBaseAttribute),f!==C&&t.removeAttr(f)),t.data(d,!0),y(T,t),h.remove(),p()});var m=(L&&A?A:t.attr(u))||"";h.attr(C,t.attr(f)).attr(F,t.attr(l)).attr(E,m?r+m:null),h.complete&&h.trigger(D)}}function A(t){var e=t.getBoundingClientRect(),r=a.scrollDirection,n=a.threshold,i=h()+n>e.top&&-n<e.bottom,o=g()+n>e.left&&-n<e.right;return"vertical"===r?i:"horizontal"===r?o:i&&o}function g(){return w>=0?w:w=n(t).width()}function h(){return B>=0?B:B=n(t).height()}function m(t){return t.tagName.toLowerCase()}function b(t,e){if(e){var r=t.split(",");t="";for(var a=0,n=r.length;a<n;a++)t+=e+r[a].trim()+(a!==n-1?",":"")}return t}function v(t,e){var n,i=0;return function(o,u){function l(){i=+new Date,e.call(r,o)}var f=+new Date-i;n&&clearTimeout(n),f>t||!a.enableThrottle||u?l():n=setTimeout(l,t-f)}}function p(){--z,i.length||z||y("onFinishedAll")}function y(t,e,n){return!!(t=a[t])&&(t.apply(r,[].slice.call(arguments,1)),!0)}var z=0,w=-1,B=-1,L=!1,T="afterLoad",D="load",I="error",N="img",E="src",F="srcset",C="sizes",O="background-image";"event"===a.bind||o?f():n(t).on(D+"."+l,f)}function a(a,o){var u=this,l=n.extend({},u.config,o),f={},c=l.name+"-"+ ++i;return u.config=function(t,r){return r===e?l[t]:(l[t]=r,u)},u.addItems=function(t){return f.a&&f.a("string"===n.type(t)?n(t):t),u},u.getItems=function(){return f.g?f.g():{}},u.update=function(t){return f.e&&f.e({},!t),u},u.force=function(t){return f.f&&f.f("string"===n.type(t)?n(t):t),u},u.loadAll=function(){return f.e&&f.e({all:!0},!0),u},u.destroy=function(){return n(l.appendScroll).off("."+c,f.e),n(t).off("."+c),f={},e},r(u,l,a,f,c),l.chainable?a:u}var n=t.jQuery||t.Zepto,i=0,o=!1;n.fn.Lazy=n.fn.lazy=function(t){return new a(this,t)},n.Lazy=n.lazy=function(t,r,i){if(n.isFunction(r)&&(i=r,r=[]),n.isFunction(i)){t=n.isArray(t)?t:[t],r=n.isArray(r)?r:[r];for(var o=a.prototype.config,u=o._f||(o._f={}),l=0,f=t.length;l<f;l++)(o[t[l]]===e||n.isFunction(o[t[l]]))&&(o[t[l]]=i);for(var c=0,s=r.length;c<s;c++)u[r[c]]=t[0]}},a.prototype.config={name:"lazy",chainable:!0,autoDestroy:!0,bind:"load",threshold:500,visibleOnly:!1,appendScroll:t,scrollDirection:"both",imageBase:null,defaultImage:"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",placeholder:null,delay:-1,combined:!1,attribute:"data-src",srcsetAttribute:"data-srcset",sizesAttribute:"data-sizes",retinaAttribute:"data-retina",loaderAttribute:"data-loader",imageBaseAttribute:"data-imagebase",removeAttribute:!0,handledName:"handled",loadedName:"loaded",effect:"show",effectTime:0,enableThrottle:!0,throttle:250,beforeLoad:e,afterLoad:e,onError:e,onFinishedAll:e},n(t).on("load",function(){o=!0})}(window);

app.components.image = {
    global: true,
    addListener: function () {
        this.lazyInstance = $("img.lazyload__image[data-src]").filter(function () {
            return $(this).closest('.swiper-slide').length === 0
        }).wrap('<div class="lazyload"></div>').lazy({
            scrollDirection: 'vertical',
            effect: 'fadeIn',
            visibleOnly: true,
            chainable: false,
            afterLoad: function (element) {
                $(element).parent('div').addClass('lazyload--loaded');
            }
        });
    }
};

app.components.course_list = {
    global: false,
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

    }
};
app.components.masonry = {
    onReady: function () {
        if ($('.section--masonry').length) {
            return true;
        }
    },
    addListener: function () {

        // super small and trash masonry layout with 2 columns
        $('.section--masonry').each(function () {

            let masonryContainer = $('.row', this);

            // remove responsive classes
            $('.col', masonryContainer).removeClass(function (index, className) {
                return (className.match(/(^|\s)col-\S+/g) || []).join(' ');
            });

            // create 2 columns
            $(masonryContainer).append('<div class="grid-col col-12 col-lg-5 col-md-5 col-sm-6"></div><div class="grid-col col-lg-5 col-md-5 col-sm-6"></div>');

            let column = [];
            column[0] = $('.grid-col', masonryContainer).eq(0);
            column[1] = $('.grid-col', masonryContainer).eq(1);

            // move col to grid col
            $('.col', masonryContainer).each(function (i, e) {
                column[ (i % 2 ? 1 : 0) ].append( this );
            });

        });

    }
};

app.components.navigation = {
    onReady: function () {
        if ($('.c-navigation__toggle').length) {
            return true;
        }
    },
    addListener: function () {
        var navigationToggle = $('.c-navigation__toggle');
        var siteContent = $('.site-content');
        var mobileNav = $('.c-navigation--mobile');
        var html = $('html');
        var navigationEl = $('.c-navigation');
        var widgetToggleEl = $('.c-contact-widget__toggle').eq(0);
        var currentWithChildren = $('li.current.menu_item_has_children', navigationEl);
        var itemsWithChildren = $('li.menu_item_has_children:not(.current)');
        var CURRENT_CLASS = 'current';

        // hide opened current submenu when hovering over menu items with children to avoid overlapping
        if(currentWithChildren.length && itemsWithChildren && CURRENT_CLASS) {
            itemsWithChildren.hover(
                function() {
                    currentWithChildren.removeClass(CURRENT_CLASS);
                  }, function() {
                    currentWithChildren.addClass(CURRENT_CLASS);
                  }
            );
        }

        navigationToggle.on("click", function () {  
            if(html.hasClass('mobile-nav-is-visible')) {
                siteContent.css({'transform' : 'translateY(0px)'});
                mobileNav.css({'height': 'auto'});
            } else {
                if(html.hasClass('is-contact-widget-open')) {
                    widgetToggleEl.trigger('click');
                }
                
                siteContent.css({'transform' : 'translateY(' + mobileNav.outerHeight() + 'px)'});
                mobileNav.css({'height': mobileNav.outerHeight() + 'px'});
            }

            html.toggleClass('mobile-nav-is-visible');
        });

        $('.c-navigation--mobile .menu li.menu_item_has_children > a').on('click', function(e){
            // we can't access to pseudo elements
            if ( $('body').width() <= 1024 ){
                var correspondingLi = $(this).parent('li');

                if ( !correspondingLi.hasClass('mouseenter') ){
                    $('.c-navigation--mobile .menu li').removeClass('mouseenter current');
                    correspondingLi.addClass('mouseenter');
                } else {
                    $('.c-navigation--mobile .menu li').removeClass('mouseenter current');
                    correspondingLi.removeClass('mouseenter');
                }

                return false;
            }
        });
        /*
        if($('body').width() > 1024 && currentWithChildren.length) {
            var header = $('.js-header');
            var subMenu = $('> ul.sub-menu', currentWithChildren);
            var subMenuOffset = subMenu.offset();

            $(window).scroll(function() {
                if($(window).scrollTop() > (subMenuOffset.top - 12)) {
                    header.addClass('is-sticky');
                    header.css({'top': -(subMenuOffset.top - 12)});
                } else {
                    header.removeClass('is-sticky');
                    header.css({'top': 0})
                }
            });
        }*/
    }
};

app.components.news = {
    onReady: function () {
        if ($('.news_list').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;
        var $container = $('.news_list');
        $('button.load', $container).on('click', function () {
            var button = $(this);
            var module = button.data('module');
            var template = button.data('template');
            var page = parseInt(button.data('page'));
            that.getNewsEntries(module, template, page);
            return false;
        });
    },
    getNewsEntries: function (module, template, page) {
        var $container = $('.news_list');
        var button = $('button.load', $container);
        var endpoint = '?module=' + module + '&options=' + ['template:' + template, 'page:' + page].join(';');
        button.attr('disabled', 'disabled');
        button.fadeIn(250);
        $.get(endpoint, function (data) {
            if (data) {
                if (page > 1) {
                    $('.news_list__entries', $container).append(data);
                } else {
                    $('.news_list__entries', $container).html(data);
                }
                button.data('page', page + 1);
                button.prop("disabled", true).removeAttr("disabled");
            } else {
                button.fadeOut(250);
            }
            $('*', $container).removeClass('loading');
        });
    }
};

app.components.partner_logos = {
    global: false,
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

    }
};
app.components.products = {
    global: false,
    onReady: function () {
        if ($('.c-products__item-content').length) {
            return true;
        }
    },
    addListener: function () {
        if ( $('body').width() <= 1024 ){
            var products = $('.c-products__item');

            products.each(function(i, el) {
                var logo = $('.c-products__logo', $(el));

                logo.on('click', function(e) {
                    $(el).toggleClass('is-open');
                });
            });
        }
    },
    resize: function(){
        $('.c-products').each(function(){
            var highestBox = 0; // Cache the highest
            $('.c-products__item .c-products__description', this).each(function(){
                if($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });
            $('.c-products__description',this).height(highestBox);
        });
    }
};
app.components.quote = {
    onReady: function () {
        if ($('.c-quote__slider').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;

        app.require(['swiper.min.js']).done(() => {

            $('.c-quote__slider').each(function () {
                var params = $(this).data('settings');

                var swiper = {
                    container: $(".swiper-container", this),
                    params: {
                        init: false,
                        speed: 1200,
                        initialSlide: Math.floor(Math.random() * Math.floor($(".swiper-container .swiper-slide", this).length)),
                        allowSlidePrev: false,
                        allowSlideNext: false,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 2
                        },
                        wrapperClass: 'swiper-wrapper',
                        slidesPerView: 'auto'
                    }
                };

                $('[class^="swiper-button-"]',  swiper.container).hide();

                swiper.instance = new Swiper(swiper.container, swiper.params);

                swiper.instance.init();

                setTimeout(function(){
                    swiper.instance.update();
                }, 1000);

            });

        });

    },
};

app.components.slider = {
    onReady: function () {
        if ($('.c-slider').length) {
            return true;
        }
    },
    addListener: function () {
        var that = this;

        app.require(['swiper.min.js']).done(() => {

            $('.c-slider').each(function () {

                $('.gallery', this).each(function() {
                    var gallery = this;
                    $("div.image:gt(0)", gallery).hide();
                    setInterval(function() {
                        $('div.image:first', gallery)
                            .fadeTo(1000, 0)
                            .next()
                            .fadeTo(1000, 1)
                            .end()
                            .appendTo(gallery);
                    }, 5000);
                });

                var params = $(this).data('settings');

                var swiper = {
                    container: $(".swiper-container", this),
                    params: {
                        init: false,
                        speed: 1200,
                        spaceBetween: 0,
                        loop: false,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 2
                        },
                        wrapperClass: 'swiper-wrapper',
                        watchSlidesVisibility: true,
                        slidesPerView: 'auto',
                        watchOverflow: true,
                        mousewheel: {
                            forceToAxis: true
                        },
                        fadeEffect: {
                            crossFade: true
                        },
                        coverflowEffect: {
                            rotate: 30,
                            slideShadows: false
                        },
                        flipEffect: {
                            rotate: 30,
                            slideShadows: false
                        },
                        cubeEffect: {
                            slideShadows: false
                        }
                    }
                };

                if (params.slidesPerView > 1){
                    swiper.params.slidesPerView = 'auto';
                }

                if (params.loop){
                    swiper.params.loop = params.loop;
                    swiper.params.loopAdditionalSlides = 1;
                }

                if (params.effect){
                    swiper.params.effect = params.effect;
                }

                if (params.autoplay){
                    swiper.params.autoplay = {
                        delay: 8000,
                        disableOnInteraction: false
                    };
                    swiper.params.watchSlidesProgress = true;
                }

                if (params.navigation){
                    swiper.params.navigation = {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    };
                } else {
                    $('[class^="swiper-button-"]',  swiper.container).hide();
                }

                if (params.pagination) {
                    swiper.params.pagination = {
                        el: '.swiper-pagination',
                        type: 'fraction',
                        clickable: false
                    };

                    swiper.instance.on('paginationUpdate', function (swiper, paginationEl) {
                        var bulletWidth = $('.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)', paginationEl).eq(2).width();
                        var index = swiper.snapIndex;
                        var translateX = index ? swiper.snapIndex * bulletWidth : 0;
                        $('span', paginationEl).fadeTo(0, 1);
                        $(paginationEl).attr('style', 'transform: translateX(-' + translateX + 'px)');
                        var fade = .75;
                        while (index > 0) {
                            index--;
                            fade -= .25;
                            $('span', paginationEl).eq(index).fadeTo(.1, fade);
                        }
                    });
                }

                if ( $(".swiper-slide", swiper.container).length <= params.slidesPerView || (!params.navigation && !params.pagination)) {
                    swiper.params.allowSlidePrev = false;
                    swiper.params.allowSlideNext = false;
                    swiper.params.simulateTouch = false;
                    swiper.params.allowTouchMove = false;
                }

                swiper.instance = new Swiper(swiper.container, swiper.params);

                if (params.autoplay) {

                    swiper.instance.on('init', function () {
                        var swiper = this;
                        swiper.progessbar = {
                            el: $('.swiper-progessbar', swiper.container),
                            percent: 0,
                            frame: swiper.params.autoplay.delay / 1000,
                            active: true,
                            stop: function () {
                                this.reset();
                                this.el.remove();
                                this.active = false;
                            },
                            reset: function () {
                                this.percent = 0;
                                this.el.hide();
                                this.step();
                                this.el.removeClass('noTransition');
                            },
                            start: function () {
                                this.percent = 100;
                                this.el.show();
                                this.step();
                            },
                            step: function () {
                                this.el.css({"width": this.percent + "%"});
                            },
                            init: function () {
                                var that = this;
                                this.reset();
                                if (this.active) {
                                    setTimeout(function () {
                                        that.el.show();
                                        that.start();
                                    }, 100);
                                }
                            }
                        };
                    });

                    swiper.instance.on('init slideChange', function () {
                        var swiper = this;
                        if (swiper.autoplay.running == true) {
                            swiper.progessbar.init();
                        }
                        // pause/autoplay >>GLOBAL<< video on slidechange
                        $('.swiper-slide', swiper.container).each(function (i, e) {
                            $(this).find('video').each(function () {
                                if (i == swiper.instance.activeIndex) {
                                    this.currentTime = 0;
                                    this.play();
                                } else {
                                    this.pause();
                                }
                            });
                        });
                    });

                    swiper.instance.on('autoplayStop', function () {
                        var swiper = this;
                        swiper.progessbar.stop();
                    });

                }

                swiper.instance.init();

                setTimeout(function(){
                    swiper.instance.update();

                }, 1000);

            });

        });

    },
    progessbar: function () {
        var that = this;
    }
};

app.components.team = {
    global: false,
    onReady: function () {
        if ($('.c-team').length) {
            return true;
        }
    },
    orderRandom: function(wrapper, elements) {
        $(wrapper).each(function(){
            var divs = $(this).find(elements);
            for(var i = 0; i < divs.length; i++) $(divs[i]).remove();
            //the fisher yates algorithm, from http://stackoverflow.com/questions/2450954/how-to-randomize-a-javascript-array
            var i = divs.length;
            if ( i == 0 ) return false;
            while ( --i ) {
                var j = Math.floor( Math.random() * ( i + 1 ) );
                var tempi = divs[i];
                var tempj = divs[j];
                divs[i] = tempj;
                divs[j] = tempi;
            }
            for(var i = 0; i < divs.length; i++) $(divs[i]).appendTo(this);
        });
    },
    orderReset: function(wrapper, elements) {
        $(wrapper).append($(wrapper).find(elements).get().sort(function(a, b) {
            return $(a).data('order') - $(b).data('order');
        }));
    },
    addListener: function () {
        var that = this;
        app.require(['flexsearch.min.js']).done(() => {
            var categoryJSON = $('#teammembersJSON');
            var departmentFilter = $('.js-team-department-select');
            var nameFilter = $('.js-team-search');
            var teammembers = $('.c-team__member');

            if(categoryJSON && departmentFilter.length && nameFilter.length) {
                categoryJSON = JSON.parse(categoryJSON.text());

                _create_select(categoryJSON);
                _initializeFlexsearch();
                _initializeDepartmentFilter();
            }

            function _create_select(categories) {
                for(let key in categories) {
                    departmentFilter.append(`<option value="${categories[key].term_id}">${categories[key].name}</option>`);
                }
            }

            function _initializeDepartmentFilter() {
                departmentFilter.change(function (e) {
                    var departmentID = $(this).val();

                    if (departmentID === '') {
                        that.orderRandom('.c-team__member-wrapper', '.c-team__member');
                        teammembers.show();
                    } else {
                        that.orderReset('.c-team__member-wrapper', '.c-team__member');
                        teammembers.hide();
        
                        var items = teammembers.filter(function () {
                            var departments = $(this).attr('data-departments') || '';
                            return departments.split(',').indexOf(departmentID) > -1;
                        });
                        items.show();
                    }
                    $(window).trigger('resize');
                });
            }

            function _initializeFlexsearch() {
                // prepare team data for JS - TODO: can be refactored to get from php to json directly
                var teammembersArray = [];
                
                teammembers.each(function() {
                    var teammember = $(this);

                    teammembersArray.push({
                        id: teammember.data('id'),
                        name: $('.c-team__member-name', teammember).text()
                    })
                });

                var searchIndex = new FlexSearch({
                    encode: 'advanced',
                    tokenize: 'reverse',
                    suggest: true,
                    cache: false,
                    doc: {
                        id: 'id',
                        field: [
                            'name',
                        ]
                    }
                });
    
                searchIndex.add(teammembersArray);
    
                nameFilter.keyup(function (e) {
                    var fieldValue = nameFilter.val();
                    var searchResults = searchIndex.search(fieldValue);
        
                    if (fieldValue === '' || fieldValue.length < 1) {
                        teammembers.show();
                    } else {
                        // reset department filter on name search
                        departmentFilter.val('').trigger('change');

                        _filterSearchMembers(searchResults, fieldValue);
                    }
    
                });
            }

            function _filterSearchMembers(results, searchString) {
                var filteredItems = [];

                var idList = results.map(function (item) {
                    return item.id;
                });
    
                teammembers.hide();
    
                if (!results.length) {
                    //nothingFoundEl.show();
                } else {
                    $.each(idList, function (index, value) {
                        var items = teammembers.filter('[data-id=' + value + ']')
                        items.show();
    
                        filteredItems.concat(items);
                    });
                }
            }
        });
    }
};
app.components.timeline = {
    global: false,
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

    }
};
app.components.values = {
    global: false,
    onReady: function () {

    },
    addListener: function () {

    },
    resize: function () {

    },
    scroll: function () {

    }
};
app.components.video = {
    onReady: () => {
        if ($('.c-video').length) {
            return true;
        }
    },
    addListener: () => {
        app.require(['fitvids.min.js']).done(() => {
            fitvids('.c-video');
        });
    }
};

$(function(){
    app.init();
});